import { render, staticRenderFns } from "./CreateOrderOfferPriceManager.vue?vue&type=template&id=0957f121&scoped=true"
import script from "./CreateOrderOfferPriceManager.vue?vue&type=script&lang=js"
export * from "./CreateOrderOfferPriceManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0957f121",
  null
  
)

export default component.exports